import React from 'react';
import { FormBuilder } from 'commons-ui';
import useEdit from './useEdit';

import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG } from '../../utils/formConfig';

const EditUser: React.FC<{}> = () => {
	const { rowData, showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();

	return (
		<FormBuilder
			data={rowData}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default EditUser;
